import { useMediaQuery } from '@mui/material';

/**
 * Notebooks e janelas baixas (ex.: 1366×768): reduz padding e altura do editor
 * para caber identificação + evolução + rodapé com menos rolagem.
 * Inclui laptops 1080p com largura típica de notebook.
 */
export function useEvolutionCompactLayout(): boolean {
  return useMediaQuery(
    '(max-height: 920px), ((max-height: 1080px) and (max-width: 1536px))',
  );
}
